module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "600px",
      "min-width": "500px"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('h2', [_vm._v("Parametrar för synkronisering")]), _vm._v(" "), _c('h3', [_vm._v("Anpassa parametrar")]), _vm._v(" "), _vm._l((_vm.params.args1), function(arg, key) {
    return _c('div', {
      class: arg.length >= 4 && arg[3] ? 'disabled' : ''
    }, [(arg[0] === 'accomodation') ? _c('div', {
      staticClass: "field"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.accomodationFilter),
        expression: "accomodationFilter"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "placeholder": "Sök boende"
      },
      domProps: {
        "value": (_vm.accomodationFilter)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.accomodationFilter = $event.target.value
        }
      }
    }), _vm._v(" "), (_vm.pools.length) ? _c('div', {
      staticClass: "list"
    }, [_c('table', _vm._l((_vm.filteredPools), function(pool, key) {
      return _c('tbody', {
        class: {
          active: pool.active
        },
        on: {
          "click": function($event) {
            return _vm.setPoolActive(pool.id, pool)
          }
        }
      }, [_c('tr', [_c('th', {
        staticStyle: {
          "text-align": "left"
        }
      }, [_vm._v(_vm._s(pool.display_name || pool.name) + " (" + _vm._s(pool.unit_count) + " st)")])]), _vm._v(" "), _vm._l((pool.units), function(unit, k) {
        return _c('tr', {
          class: {
            active: unit.active
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.setUnitActive(unit.id, pool.id)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(unit.description_title || unit.name))])])
      })], 2)
    }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.pools.length) ? _c('div', {
      staticClass: "list"
    }, [_vm._v("\n        laddar...\n      ")]) : _vm._e(), _vm._v("\n\n      " + _vm._s(_vm.selectedCount || 'Alla') + " boenden valda\n    ")]) : _vm._e(), _vm._v(" "), (arg[0] === 'switch') ? _c('div', {
      staticClass: "field"
    }, [_c('SwitchButton', {
      attrs: {
        "store": key,
        "iconscale": 2,
        "value": arg[2],
        "sync": false,
        "labels": {
          checked: arg[1],
          unchecked: arg[1]
        }
      },
      on: {
        "toggle": _vm.toggle
      }
    })], 1) : _vm._e(), _vm._v(" "), (arg[0] === 'text') ? _c('div', {
      staticClass: "field"
    }, [_vm._v("\n      " + _vm._s(arg[1]) + "\n      "), _c('input', {
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": arg[2]
      },
      on: {
        "keyup": function($event) {
          return _vm.updateArg1($event, key)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (arg[0] === 'text-readonly') ? _c('div', {
      staticClass: "field"
    }, [_vm._v("\n      " + _vm._s(arg[1]) + "\n      "), _c('input', {
      attrs: {
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": arg[2]
      }
    })]) : _vm._e()])
  }), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('h3', [_vm._v("Övriga parametrar")]), _vm._v(" "), _vm._l((_vm.params.args2), function(arg, key) {
    return _c('div', [_vm._v("\n    " + _vm._s(arg) + "\n  ")])
  }), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.goOn
    }
  }, [_vm._v("Kör")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91576fce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/AdminSyncFields.vue
// module id = 1001
// module chunks = 0